// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__AuthenticationPage__root","card":"cms__AuthenticationPage__card","button":"cms__AuthenticationPage__button"};


//////////////////
// WEBPACK FOOTER
// ./backends/netlify-auth/AuthenticationPage.css
// module id = 545
// module chunks = 0